import {html, nothing} from 'lit';
import {customElement} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {map} from 'rxjs';
import {ActivityOption} from './activity-option';
import {Panel} from './panel';
import {ri} from './runner-idle';
import {formatResourceValue, formatDelta, formatTime} from './utils';
import * as D from './decimal_utils';

@customElement('ri-resources-delta')
export class ResourcesDelta extends Panel {
  // #region Properties (2)

  public override id = 'resources-delta';
  public override name = 'Changes Last Queue';

  // #endregion Properties (2)

  // #region Public Methods (1)
  constructor() {
    super();
    this.unlock$ = ri.stats.intelligence.value$.pipe(map(D.gte(10)));
  }

  public override render() {
    return super.render(html`
      <div id="queue-loop-delta">
        <div class=".container">
          ${(function () {
            const resourcesElement =
              ri.shadowRoot?.querySelector('ri-resources');
            if (!resourcesElement) return nothing;
            return unsafeHTML(
              Object.entries(ri.lastQueueLoopDelta)
                .filter(([_string, filterable]) => {
                  if ('unlocked' in filterable && !filterable.unlocked)
                    return false;
                  let include = resourcesElement.isIntersection;
                  for (const filter of resourcesElement.filters) {
                    // Skip any special filters
                    if (
                      [...resourcesElement.possibleFilters].find(
                        (f) => f.name === filter
                      )?.condition
                    )
                      continue;
                    if (resourcesElement.isIntersection) {
                      if (!filterable.tags.has(filter)) {
                        include = false;
                        break;
                      }
                    } else {
                      if (filterable.tags.has(filter)) {
                        include = true;
                        break;
                      }
                    }
                  }
                  for (const filter of resourcesElement.possibleFilters) {
                    if (filter.condition) {
                      if (filter.only) {
                        if (resourcesElement.filters.has(filter.name)) {
                          include = filter.condition(filterable);
                        }
                        continue;
                      }
                      if (
                        !resourcesElement.filters.has(filter.name) &&
                        filter.condition(filterable)
                      ) {
                        include = false;
                        break;
                      }
                    }
                  }
                  return include;
                })
                .sort(([, a], [, b]) => resourcesElement.compare(a, b))
                .filter(
                  (entry) =>
                    !entry[1].value.equals(0) ||
                    (entry[1].capacity && !entry[1].capacity.equals(0))
                )
                // Repeatedly searching like resourcesElement is expensive
                .filter((entry) => {
                  const unlockable = ri.unlockables.find(
                    (e) => e.name == entry[0]
                  );
                  if (unlockable) return unlockable.unlocked;
                  return true;
                })
                .map((entry) => {
                  const unlockable = ri.unlockables.find(
                    (e) => !(e instanceof ActivityOption) && e.name == entry[0]
                  );
                  return `<div class="ri-loop-delta flex-horizontal ${
                    entry[0]
                  }" ${
                    entry[0] == 'distance' || unlockable?.unlocked
                      ? ''
                      : 'hidden'
                  }>
                    <div class="ri-loop-delta-label">
                      <span class="fancy ${unlockable?.name}">${
                    unlockable ? unlockable.displayName : entry[1].displayName
                  }</span>
                      ${formatResourceValue(entry[1].value)}
                    </div>
                    <div>
                    <span>${
                      entry[1]?.capacity && !entry[1].capacity.equals(0)
                        ? ` Capacity ${formatDelta(entry[1].capacity)}`
                        : ''
                    }</span>
                    </div>
                    <div>
                    <span>${formatDelta(entry[1].perSecond)}/s
                      </span>
                      <span class="${
                        entry[1].perSecond?.lt(0) ? 'danger' : ''
                      }">${
                    entry[1].timeToFullOrEmpty
                      ? formatTime(entry[1].timeToFullOrEmpty())
                      : ''
                  }</span>
                    </div>
                    </div>`;
                })
                .join('')
            );
          })()}
        </div>
      </div>
    `);
  }

  // #endregion Public Methods (1)
}
